module.exports = __webpack_public_path__ + "static/universal-life-insurance-hero-mobile.28a9a4a4.webp";